import { Selector } from 'react-redux';
import { RootState } from 'redux/store';
import { ConfigurationState } from '.';

export const selectConfiguration: Selector<RootState, ConfigurationState> = (state: RootState) =>
    state.configuration as ConfigurationState;
